import { defineStore } from 'pinia'
import type { Organization } from '~/repository/types/organization'
import { type IApiInstance } from '../plugins/api'

export type IOrganizationsState = {
  isLoaded: boolean
  organizations: Organization[]
  cmsOrganization: any[]
}

export const useOrganizationsStore = defineStore('organizations', {
  state: (): IOrganizationsState => {
    return {
      isLoaded: false,
      organizations: [],
      cmsOrganization: [],
    }
  },
  getters: {
    getOrganizationById: (state) => (id: string) => {
      return id ? state.organizations.find((t: Organization) => t && t.id === id) : null
    },
    getOrganizationCount: (state) => (): number => {
      return state.organizations.length
    },
    getOrganizationsAsChoiceValues: (state) => () => {
      const choices: { value: string; title: string }[] = []
      state.organizations.forEach((o: Organization) => {
        choices.push({ value: o.id, title: o.name })
      })
      return choices
    },
  },
  actions: {
    async load() {
      const api: IApiInstance = useNuxtApp().$api as IApiInstance

      this.organizations = await api.organizations.getV2()
      this.cmsOrganization = await api.cms.getOrganisation()
      if (this.organizations) {
        this.isLoaded = true
      }
    },
    async save(updatedItem: Partial<Organization>) {
      this.isLoaded = false
      try {
        const api: IApiInstance = useNuxtApp().$api as IApiInstance

        const response = await api.organizations.save(updatedItem)

        const index = this.organizations.findIndex((o: Organization) => o.id === updatedItem?.id)

        if (index !== -1) {
          this.organizations[index] = response
        } else {
          this.organizations.push(response)
        }
      } catch (error) {
        // TODO: Add an error handling system
        throw error
      } finally {
        this.isLoaded = true
      }
    },
    /**
     * An action to clear the user data from the storage, should be used upon signing out the user.
     *
     * @param {object} context - VueX store context containing commit helper for mutations.
     */
    clear() {
      this.$reset()
    },
  },
})
